<template>
  <v-container fluid grid-list-md>
    <v-layout column wrap>
      <v-flex>
        <h1 class="display-3">Coordinación de despachos</h1>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex sm3>
        <v-text-field clearable prepend-icon="search" v-model="search"></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-list three-line v-if="movil">
          <template v-for="(item, index) in items">
            <v-divider></v-divider>
            <v-list-tile @click.native.stop="sel = item; dialog = true">
              <v-list-tile-action class="text-xs-center">
                <v-chip :color="item.estadoCreditoColor" label small>
                  <span class="white--text">Estado Adm</span>
                </v-chip>
                <v-chip :color="item.estadoStockColor" label small>
                  <span class="white--text">Estado Stock</span>
                </v-chip>
              </v-list-tile-action>
              <v-list-tile-content :class="[item.bodegajeDias < 0 ? 'red--text' : 'green--text']">
                <v-list-tile-title>PV {{ item.C6_NUM }} | PRESUP {{ item.C5_USREQVE }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.A1_NOME }}</v-list-tile-sub-title>
                <v-list-tile-sub-title>{{ item.B1_DESC }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action class="text-xs-center">
                {{ item.cantPendiente | moneda }} {{ item.C6_UM }}
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
        <v-dialog v-model="dialog" scrollable fullscreen>
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click.native="dialog = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Datos</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-text-field readonly label="PV" v-model="sel.C6_NUM"></v-text-field>
              <v-text-field readonly label="Presupuesto" v-model="sel.C5_USREQVE"></v-text-field>
              <v-text-field readonly label="Cliente" v-model="sel.A1_NOME"></v-text-field>
              <v-text-field readonly label="Vendedor" v-model="sel.A3_NOME"></v-text-field>
              <v-text-field readonly label="Producto" v-model="sel.B1_DESC"></v-text-field>
              <v-text-field readonly label="Cantidad" v-model="cant"></v-text-field>
              <v-text-field readonly label="Cant. Pendiente" v-model="cantPend"></v-text-field>
              <v-text-field readonly label="Vencimiento" v-model="sel.C6_ENTREG"></v-text-field>
              <v-text-field readonly label="Bodegaje" v-model="sel.bodegaje"></v-text-field>
              <v-text-field readonly label="Depósito" v-model="sel.C6_LOCAL"></v-text-field>
              <v-text-field readonly label="Estado crédito" v-model="sel.estadoCredito"></v-text-field>
              <v-text-field readonly label="Estado Stock" v-model="sel.estadoStock"></v-text-field>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1 tabla-compacta-col"
            :pagination.sync="pag"
            :total-items="totalItems"
            :rows-per-page-items="rows"
            :search="search"
            disable-initial-sort
            no-data-text="No hay datos"
            v-if="!movil"
            :loading="loading"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.C6_NUM }}</td>
            <td class="text-xs-center">{{ props.item.C5_USREQVE }}</td>
            <td class="text-xs-center">
              <div style="width: 300px">{{ props.item.A1_NOME }}</div>
            </td>
            <td class="text-xs-center">{{ props.item.A3_NOME }}</td>
            <td class="text-xs-center" @click="decodifica(props.item.B1_COD,props.index)">
              {{ props.item.B1_DESC }}
              <v-progress-circular v-if="props.index === loadingDec" indeterminate color="primary" :size="15"
                                   :width="1"></v-progress-circular>
            </td>
            <td class="text-xs-right">{{ props.item.C6_QTDVEN | moneda }}</td>
            <td class="text-xs-right">{{ props.item.entregado | moneda }}</td>
            <td class="text-xs-right">{{ props.item.cantPendiente | moneda }}</td>
            <td class="text-xs-center">{{ props.item.C6_ENTREG | fecha }}</td>
            <td class="text-xs-center" :class="[props.item.bodegajeDias < 0 ? 'red--text' : 'green--text']">
              {{ props.item.bodegaje }}
            </td>
            <td class="text-xs-center">{{ props.item.C6_LOCAL }}</td>
            <td class="text-xs-center">
              <v-chip small text-color="white" :color="props.item.estadoCreditoColor">{{
                  props.item.estadoCredito
                }}
              </v-chip>
            </td>
            <td class="text-xs-center">
              <v-menu offset-y left>
                <v-chip slot="activator" small text-color="white" :color="props.item.estadoStockColor">
                  {{ props.item.estadoStock }}
                </v-chip>
                <v-list>
                  <v-list-tile @click="">
                    <v-list-tile-avatar>
                      <v-icon>account_circle</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Responsable de deposito</v-list-tile-title>
                      <v-list-tile-sub-title>{{ props.item.Z21_RNOM }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="">
                    <v-list-tile-avatar>
                      <v-icon>email</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Email de responsable</v-list-tile-title>
                      <v-list-tile-sub-title>{{ props.item.Z21_REPEM }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="">
                    <v-list-tile-avatar>
                      <v-icon>place</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Dirección del deposito</v-list-tile-title>
                      <v-list-tile-sub-title>{{ props.item.Z21_DIR }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="">
                    <v-list-tile-avatar>
                      <v-icon>local_phone</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Teléfono del deposito</v-list-tile-title>
                      <v-list-tile-sub-title>{{ props.item.Z21_TEL }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="copiarDatos(props.item)">
                    <v-list-tile-avatar>
                      <v-icon>content_copy</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Copiar datos</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="decodifica(props.item.B1_COD,props.index)">
                    <v-list-tile-avatar>
                      <v-icon>content_copy</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Decodifica</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </template>
        </v-data-table>
        <errores v-model="msj.mostrar" :datos="msj"></errores>
        <v-dialog v-model="dialogCodigo" max-width="500px" scrollable>
          <v-card>
            <v-card-title class="headline grey lighten-2">
              <span>Decodificación</span>
            </v-card-title>
            <v-card-text>
              <v-list>
                <template v-for="d in decodif">
                  <v-list-tile>
                    <v-list-tile-title><b>{{ d.tit }}</b></v-list-tile-title>
                    <v-list-tile-sub-title>{{ d.desc }}</v-list-tile-sub-title>
                  </v-list-tile>
                </template>
              </v-list>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.stop="dialogCodigo=false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
import mixinUsers from '../../mixins/auth/users';
import mixinPanel from '../../mixins/panel';
import monedaFilter from '../../filters/moneda';
import fechaMicro from '../../filters/fecha-micro';
import empresaChip from '../../components/EmpresaChip';
import errores from '../../components/Errores'
import {mapGetters} from 'vuex'

export default {
  name: "coord-despachos",
  layout: 'default',
  filters: {
    moneda: monedaFilter,
    fecha: fechaMicro
  },
  components: {empresaChip, errores},
  mixins: [mixinUsers, mixinPanel],
  data() {
    return {
      search: '',
      loadingDec: -1,
      dialog: false,
      dialogCodigo: false,
      msj: {
        mostrar: false,
        txt: '',
        tipo: ''
      },
      indeterminado: true,
      loading: false,
      headers: [
        {text: 'PV', value: 'C6_NUM', align: 'center', width: 10},
        {text: 'Presupuesto', value: 'C5_USREQVE', align: 'center', width: 10},
        {text: 'Cliente', value: 'A1_NOME', align: 'center'},
        {text: 'Vendedor', value: 'A3_NOME', align: 'center'},
        {text: 'Producto', value: 'B1_DESC', width: '800px', align: 'center'},
        {text: 'Cant', value: 'C6_QTDVEN', align: 'center'},
        {text: 'Entregado', value: 'entregado', align: 'center'},
        {text: 'Cant pendiente', value: 'cantPendiente', align: 'center'},
        {text: 'Vencimiento', value: 'C6_ENTREG', align: 'center'},
        {text: 'Bodegaje', value: 'bodegaje', align: 'center'},
        {text: 'Dep', value: 'C6_LOCAL', align: 'center'},
        {text: 'Estado crédito', value: 'estadoCredito', align: 'center'},
        {text: 'Estado stock', value: 'estadoStock', align: 'center'},
      ],
      items: [],
      pag: {},
      rows: [10, 20, 30, {text: 'All', value: -1}],
      totalItems: 0,
      vendedores: [],
      vendedor: '',
      sel: {
        C6_NUM: '',
        C5_USREQVE: '',
        A1_NOME: '',
        A3_NOME: '',
        B1_DESC: '',
        C6_QTDVEN: '',
        cantPendiente: '',
        C6_ENTREG: '',
        bodegaje: '',
        C6_LOCAL: '',
        estadoCredito: '',
        estadoStock: ''
      },
      decodif: []
    }
  },
  computed: {
    ...mapGetters('config', ['movil']),
    cant() {
      return new Intl.NumberFormat('es-AR').format(this.sel.C6_QTDVEN);
    },
    cantPend() {
      return new Intl.NumberFormat('es-AR').format(this.sel.cantPendiente);
    }
  },
  mounted() {
    this.consulta()
  },
  methods: {
    decodifica(codigo, indx) {
      this.loadingDec = indx;
      this.panelDecodifica(codigo, r => {
        this.decodif = r;
        this.dialogCodigo = true;
        console.log(codigo)
        this.loadingDec = -1;
      }, err => {
        console.log(err)
        this.loadingDec = -1;
      })
    },
    consulta() {
      this.loading = true;
      this.$http.post('informes/coord-despacho/consulta')
          .then(r => {
            this.items = r.data;
            this.loading = false;
          })
    },
    copiarDatos(itm) {
      let txt = 'Responsable: ' + itm.Z21_RNOM.trim() +
          ' | Email: ' + itm.Z21_REPEM.trim() +
          ' | Dirección: ' + itm.Z21_DIR.trim() +
          ' | Teléfono: ' + itm.Z21_TEL.trim();
      this.$copyText(txt)
          .then(r => {
            this.msj = {
              tipo: 'success',
              txt: 'Datos copiados al portapapeles',
              mostrar: true
            };
            console.log(r)
          }, err => {
            this.msj = {
              tipo: 'error',
              txt: 'Error al copiar datos',
              mostrar: true
            };
            console.log(err)
          })
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/informes/coord-despachos.vue